// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__3rnjk","wrapper":"Menu_wrapper__NkxOe","btn":"Menu_btn__jKSFx"};